import { gql } from '@apollo/client';

export const UPSERT_SITE = gql`
  mutation UpsertSite($input: UpsertSiteInput!) {
    site: upsertSite(input: $input) {
      id
    }
  }
`;
